import "./index.scss";

export const DeviceVerificationHeader = ({ isStartPage }) => (
  <div className="device-verification-header">
    <h1>Verify Your Device</h1>
    {isStartPage ? (
      <p>
        Please verify your device using one of the following methods. We'll
        provide you with a verification code to access your GCX account.
      </p>
    ) : (
      <p>
        Please enter your device verification code below.
        <br />
        After confirming your device, you will have full access to GCX and your
        account.
      </p>
    )}
  </div>
);
